import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  Meter,
  MeteringOrMarketLocation
} from "../../../../utils/backend-types";
import { ObjectName } from "../../../../utils/enums";
import { ComponentOpenEditModalLink } from "../../ComponentOpenEditModalLink/ComponentOpenEditModalLink";
import type { ConfiguratorComponent } from "../ComponentTable";

interface GetMeterCustomColumnsProps {
  meteringOrMarketLocations?: Array<MeteringOrMarketLocation>;
  projectId: string;
  siteId: number;
}

function getMeterCustomColumns({
  meteringOrMarketLocations,
  projectId,
  siteId
}: GetMeterCustomColumnsProps): Array<MRT_ColumnDef<ConfiguratorComponent>> {
  return [
    {
      header: "Zählernummer",
      accessorKey: "number"
    },
    {
      header: "Mess- oder Marktlokation Einspeisung",
      accessorFn: (rowData) =>
        getMeterNameWithNumber({
          rowLocation: (rowData as Meter).locationFeedin,
          allLocations: meteringOrMarketLocations || []
        }),
      Cell: ({ cell, row }) => {
        const locationFeedin = (row.original as Meter).locationFeedin;
        return (
          locationFeedin && (
            <ComponentOpenEditModalLink
              componentId={locationFeedin}
              linkContent={cell.getValue<string | number | null>()}
              objectName={ObjectName.MeteringOrMarketLocation}
              projectId={projectId}
              siteId={siteId}
            />
          )
        );
      }
    },
    {
      header: "Mess- oder Marktlokation Entnahme",
      accessorFn: (rowData) =>
        getMeterNameWithNumber({
          rowLocation: (rowData as Meter).locationFeedout,
          allLocations: meteringOrMarketLocations || []
        }),
      Cell: ({ cell, row }) => {
        const locationFeedout = (row.original as Meter).locationFeedout;
        return (
          locationFeedout && (
            <ComponentOpenEditModalLink
              componentId={locationFeedout}
              linkContent={cell.getValue<string | number | null>()}
              objectName={ObjectName.MeteringOrMarketLocation}
              projectId={projectId}
              siteId={siteId}
            />
          )
        );
      }
    },
    {
      header: "Messrichtung",
      accessorKey: "meteringDirectionLabel"
    }
  ];
}

export function getMeterNameWithNumber({
  rowLocation,
  allLocations
}: {
  rowLocation?: Meter["locationFeedin" | "locationFeedout"];
  allLocations: Array<MeteringOrMarketLocation>;
}) {
  const matchingLocation = allLocations?.find(
    (location) => location.id === rowLocation
  );

  if (!matchingLocation) {
    return rowLocation;
  }
  if (matchingLocation.name !== matchingLocation.number) {
    return `${matchingLocation.name} (${matchingLocation.number})`;
  }
  return matchingLocation.name;
}

export { getMeterCustomColumns };
